import React from 'react';
import { observer } from 'mobx-react-lite';
import { DragElementWrapper, DragSourceOptions } from 'react-dnd';
import { ReactComponent as DragDropIcon } from 'components/icons/drag-n-drop.svg';
import { ReactComponent as SubstitutionIcon } from 'components/icons/substitution.svg';
import { IApiLineupPlayer } from '@trackman/baseball-shared-components';
import classNames from 'classnames';
import { Tooltip } from '@mui/material';
import './LineupBatter.css';
import { BatterPosition, Controls, DNDWrapper, Name, TaggingLineupPlayerWrapper } from '../TaggingLineupPlayerStyles';

interface IProps {
  player: IApiLineupPlayer;
  drag?: DragElementWrapper<DragSourceOptions>;
  index: string;
  isCurrent: boolean;
  onClickPlayerCallback: (playerId: string) => void;
  onClickSubstitutionCallback?: (e: React.SyntheticEvent, player: IApiLineupPlayer) => void;
  disabled?: boolean;
  isBattingPractice?: boolean;
}

export const LineupBatter: React.FC<IProps> = observer((props) => {
  const { player, drag, index, isCurrent, onClickPlayerCallback, onClickSubstitutionCallback, disabled, isBattingPractice } = props;

  const lineupBatterClasses = classNames({
    current: isCurrent,
    disabled,
  });

  return (
    <TaggingLineupPlayerWrapper
      className={`batter ${lineupBatterClasses}`}
      onClick={() => onClickPlayerCallback(player.id)}
      current={isCurrent}
      data-testid={`player-item-${index}`}
    >
      <span>{`${index}.`}</span>
      <Name>{player.nameRef}</Name>
      <Controls>
        {player.jerseyNumber && <span className='jersey-number'>#{player.jerseyNumber}</span>}
        {!isBattingPractice && (
          <>
            <Tooltip title='Quick subs' arrow componentsProps={{ tooltip: { className: 'lineup-batter-tooltip' } }}>
              <SubstitutionIcon
                onClick={(e: React.SyntheticEvent) => onClickSubstitutionCallback && onClickSubstitutionCallback(e, player)}
                data-testid={`quick-sub-${index}`}
              />
            </Tooltip>
            <BatterPosition>{player.position}</BatterPosition>
            <DNDWrapper ref={player && !disabled ? drag : undefined}>
              <DragDropIcon />
            </DNDWrapper>
          </>
        )}
      </Controls>
    </TaggingLineupPlayerWrapper>
  );
});
